import { Star } from "lucide-react";

export const SpinBadge = () => (
  <div className="relative w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-[var(--sun)] sticker-sm grid place-items-center">
    <svg viewBox="0 0 120 120" className="absolute inset-0 w-full h-full spin-slow">
      <defs>
        <path id="circ" d="M60,60 m-44,0 a44,44 0 1,1 88,0 a44,44 0 1,1 -88,0" />
      </defs>
      <text className="font-display" fontSize="13" fontWeight="600" letterSpacing="3" fill="#1B1A2E">
        <textPath href="#circ">100% KID POWERED • SAVING UP •</textPath>
      </text>
    </svg>
    <Star className="w-8 h-8 fill-[var(--coral)] text-[var(--ink)]" strokeWidth={2.5} />
  </div>
);
